import SHA256 from "crypto-js/sha256";
import { getUserEnv } from "./getUserEnv";
import { trackClarityEvent, setClarityTags } from "./clarityTracking";
import {
  DEFAULT_LOCALE,
  getBaseLang,
  getCurrency,
  getLocaleFromPath,
} from "../../config/locales";

export const trackPageView = ({ page_location, page_title, user, locale }) => {
  const activeLocale =
    locale ?? getLocaleFromPath(window.location.pathname) ?? DEFAULT_LOCALE;

  const email = user?.email || "";
  const hashedEmail = email
    ? SHA256(email.trim().toLowerCase()).toString()
    : null;

  // GTM tracking
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    page_location,
    page_title,
    user_env: getUserEnv(),
    user_language: getBaseLang(activeLocale),
    currency: getCurrency(activeLocale),
    ...(hashedEmail && { user_email_hash: hashedEmail }),
    // Plain email for Google Enhanced Conversions (Google hashes it on their end).
    ...(email && { user_email: email.trim().toLowerCase() }),
  });

  // Clarity tracking
  if (user) {
    setClarityTags(user, activeLocale);
  }
  trackClarityEvent("page_view", {
    page_location,
    page_title,
  });
};
